import { Geometry } from "geojson";
import { OnDataReadyListener } from "./OnDataReadyListener";
import { LocationItem, ResponseStatus } from "./GeoService";

export type CacheKey =
	| [country: string, state: string, county: string] //
	| [country: string, state: string]
	| [country: string];

export type JobId = string;
export type JobIdResponse = { jobId: JobId };

export type CacheHitResponse = {
	resolved: true;
	validUntil: number;
	value: LocationItem | null;
	status?: ResponseStatus;
};

export type ServiceCacheEntry = JobIdResponse | CacheHitResponse;
export function isJobIdResponse(entry: ServiceCacheEntry): entry is JobIdResponse {
	return (entry as any).jobId && !(entry as any).resolved;
}
export function isCacheHitResponse(entry: ServiceCacheEntry): entry is CacheHitResponse {
	return !(entry as any).jobId && (entry as any).resolved;
}

export interface ServiceCache {
	getEntry(key: CacheKey): ServiceCacheEntry;
	addDataReadyListener(jobId: JobId, listener: OnDataReadyListener): void;
}
